import { useEffect, useState } from 'react';

export const AI_PARSE_PROGRESS_STEPS = [
  {
    key: 'reading',
    percent: 0,
    title: 'Reading your CV',
    detail: 'Finding roles, education, and contact details.',
  },
  {
    key: 'extracting',
    percent: 25,
    title: 'Extracting experience',
    detail: 'Turning work history into structured profile sections.',
  },
  {
    key: 'enhancing',
    percent: 55,
    title: 'Improving the wording',
    detail: 'Sharpening summary, skills, and highlights.',
  },
  {
    key: 'preparing',
    percent: 80,
    title: 'Preparing your CV',
    detail: 'Getting the next review step ready.',
  },
] as const;

const TICK_MS = 160;
const TARGET_PERCENT = 95;
const APPROACH_RATE = 0.025;

export function useAiParseProgress(isActive: boolean) {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setPercent(0);
      return;
    }

    setPercent(0);
    const timer = setInterval(() => {
      setPercent((current) => {
        const next = current + (TARGET_PERCENT - current) * APPROACH_RATE;
        return next >= TARGET_PERCENT ? TARGET_PERCENT : next;
      });
    }, TICK_MS);

    return () => clearInterval(timer);
  }, [isActive]);

  const rounded = Math.round(percent);
  let stepIndex = 0;
  for (let i = 0; i < AI_PARSE_PROGRESS_STEPS.length; i += 1) {
    if (rounded >= AI_PARSE_PROGRESS_STEPS[i].percent) {
      stepIndex = i;
    }
  }
  const stepConfig = AI_PARSE_PROGRESS_STEPS[stepIndex];

  return {
    stepIndex,
    step: { ...stepConfig, percent: rounded },
    totalSteps: AI_PARSE_PROGRESS_STEPS.length,
  };
}
